import React, {Component} from 'react';
import MarkupToolButton from './MarkupToolButton';
import MarkupSubMenu from './MarkupSubMenu';
import classNames from 'classnames';
import FileAttach from '../../../components/FileAttach';

class MarkupMainMenu extends Component {

    render() {
        const {showPicker, handleCanvasImage, isSubMenu, changeColor, activateImage, mainButtons, activeColor, type, activeThickness, changeThickness,
            addShape, activeShape
        } = this.props;

        const centerClasses = classNames({
            "markup-center-actions": true,
            "sub-menu": isSubMenu
        })

        return (
            <div className={centerClasses}>
                <div className='main-menu'>
                    {!isSubMenu && mainButtons.map((props) => {
                        if (props.isAttach) {
                            return (
                                <FileAttach
                                    multiple={false}
                                    fileExtension="image/*"
                                    onChange={activateImage}
                                    key={props.buttonClass}>
                                    <MarkupToolButton {...props}/>
                                </FileAttach>
                            )
                        }
                        return <MarkupToolButton key={props.buttonClass} {...props}/>
                    })}
                </div>

                {isSubMenu && <MarkupSubMenu
                    activeThickness={activeThickness}
                    type={type}
                    activeColor={activeColor}
                    showPicker={showPicker}
                    changeColor={changeColor}
                    changeThickness={changeThickness}
                    addShape={addShape}
                    activeShape={activeShape}
                    handleCanvasImage={handleCanvasImage}
                />}
            </div>
        );
    }
}


export default MarkupMainMenu;
